module.exports = __webpack_public_path__ + "static/media/logo-cajari.c4cbe5a9.png";